jQuery(document).ready(function($) {


    if ($('.mobile-column-slides').length < 1) {
        return;
    }

    //////////
    // init
    //////////

    $("<div class='mobile-slides-nav'></div>").appendTo($('.mobile-column-slides'));

    ///////////////////////////////////
    // Go through each slide container
    ///////////////////////////////////

    $('.mobile-column-slides').each(function(i,slideContainer){

        var scrollableDiv = $(slideContainer).find(
            '.elementor-posts-container.elementor-posts,'+
            '.elementor-row,'+
            '.mcs-row'
        );
        var slides = $(slideContainer).find(
            '.elementor-posts-container.elementor-posts > article,' +
            '.elementor-row .elementor-column,' +
            '.mcs-row .mcs-column'
        );
        var nav = $(slideContainer).find('.mobile-slides-nav');
        var defaultTiming = 10000; // 10 seconds
        var interval = defaultTiming * $(slides).length;

        $(slides).each(function(ix,slide){ // each slide
            var timeout = defaultTiming * ix;
            var active = ix === 0 ? ' active' : '';
            $("<div class='slide-indicator" + active + "' data-id=" + (ix + 1) + "></div>").appendTo($(nav));
        
            setTimeout(function(){
                setInterval(function(){
                    // get current section
                    var selectedSlide = determineCurrentSlide(slides,scrollableDiv);
                    
                    // scroll to next one
                    if ((selectedSlide + 1) < slides.length ) {

                        var newSlideLocation = $(slides[selectedSlide + 1])[0].offsetLeft;
                        
                        // scroll to next
                        // $(scrollableDiv).scrollLeft(newSlideLocation);
                        $(scrollableDiv).animate({scrollLeft: newSlideLocation}, 300);

                    } else {    
                        // scroll to first
                        // $(scrollableDiv).scrollLeft(0);
                        $(scrollableDiv).animate({scrollLeft: 0}, 10);

                    }
                    
                },interval);
            },timeout);

        }); // each slide

        //////////////////////
        // On Scroll Sideways
        //////////////////////


        scrollableDiv.scroll(function(){

            // var container = $(this);
            var indicators = $(this).parents('.mobile-column-slides').find('.slide-indicator');

            var selectedSlide = determineCurrentSlide(slides,scrollableDiv);
            updateNav(indicators,selectedSlide);

        });
        
    }); // each slide container

    function determineCurrentSlide(slides,container) {

        var selectedSlide = 0;
        $(slides).each(function(iy,sld){

            if (container.scrollLeft() >= sld.offsetLeft ) {
                selectedSlide = iy;
            }
        });
        return selectedSlide;
    }

    ///////////
    // Set nav
    //////////

    function updateNav(indicators,i) {

        // highlight active slide indicator
        $(indicators).each(function(i,el){

            $(el).removeClass('active')
        });
        $(indicators[i]).addClass('active');
    }


});

